var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Search as SemanticSearch } from "semantic-ui-react";
import "../../styles/Search.module.scss";
var Search = function (props) { return _jsx(SemanticSearch, __assign({}, props), void 0); };
export default Search;
